import { formatAsPhoneNumber, isValidCnpj, isValidCpf, mask, maskCnpj, maskCpf } from '@ibk/shared-utils';
import { PixType as PixTypeEnum } from '../enums';
import { formatAsRandomPixKey, formatIdentificationNumber, formatIdentificationNumberAlphanumeric, } from './pixFormatters';
export var PixType;
(function (PixType) {
    PixType["EMAIL"] = "EMAIL";
    PixType["TAX_IDENTIFIER"] = "TAX_IDENTIFIER";
    PixType["PHONE"] = "PHONE";
    PixType["RANDOM"] = "RANDOM";
})(PixType || (PixType = {}));
export function formatPixKey(key, type) {
    if (!key || typeof key !== 'string') {
        return '';
    }
    if (!Object.values(PixType).includes(type)) {
        return key;
    }
    switch (type) {
        case PixType.TAX_IDENTIFIER: {
            if (isValidCpf(key))
                return maskCpf(key);
            if (isValidCnpj(key))
                return maskCnpj(key);
            return '';
        }
        case PixType.PHONE: {
            let phoneDigits = key.replace(/\D/g, '');
            if (phoneDigits.startsWith('55') && phoneDigits.length > 11) {
                phoneDigits = phoneDigits.substring(2);
            }
            if (phoneDigits.length === 11) {
                return mask(phoneDigits, '(##) #####-####');
            }
            if (phoneDigits.length === 10) {
                return mask(phoneDigits, '(##) ####-####');
            }
            return key;
        }
        case PixType.EMAIL:
        case PixType.RANDOM:
        default:
            return key;
    }
}
export function formatPixKeyAlphanumeric(key, type, helpers) {
    if (!key || typeof key !== 'string') {
        return '';
    }
    if (!Object.values(PixType).includes(type)) {
        return key;
    }
    if (type === PixType.TAX_IDENTIFIER) {
        if (isValidCpf(key))
            return maskCpf(key);
        if (helpers.isValidCnpj(key))
            return helpers.maskCnpj(key);
        return '';
    }
    return formatPixKey(key, type);
}
export function formatPixKeyByKeyType(keyType, value) {
    if (!value)
        return;
    if (!keyType)
        return value;
    return {
        [PixType.TAX_IDENTIFIER]: formatIdentificationNumber(value),
        [PixTypeEnum.TAX_IDENTIFIER]: formatIdentificationNumber(value),
        [PixType.EMAIL]: value.toLowerCase(),
        [PixTypeEnum.EMAIL]: value.toLowerCase(),
        [PixType.PHONE]: formatAsPhoneNumber(value),
        [PixTypeEnum.PHONE]: formatAsPhoneNumber(value),
        [PixType.RANDOM]: formatAsRandomPixKey(value),
        [PixTypeEnum.RANDOM]: formatAsRandomPixKey(value),
    }[keyType];
}
export function removeFormatOfPixKeyByKeyType(keyType, value) {
    if (!value)
        return;
    if (!keyType)
        return value;
    return {
        [PixType.TAX_IDENTIFIER]: value.replace(/\D/g, ''),
        [PixTypeEnum.TAX_IDENTIFIER]: value.replace(/\D/g, ''),
        [PixType.EMAIL]: value.toLowerCase(),
        [PixTypeEnum.EMAIL]: value.toLowerCase(),
        [PixType.PHONE]: value.replace('+55', '').replace(/\D/g, ''),
        [PixTypeEnum.PHONE]: value.replace('+55', '').replace(/\D/g, ''),
        [PixType.RANDOM]: value.replaceAll('-', ''),
        [PixTypeEnum.RANDOM]: value.replaceAll('-', ''),
    }[keyType];
}
export function formatPixKeyByKeyTypeAlphanumeric(keyType, value, helpers) {
    if (!value)
        return;
    if (!keyType)
        return value;
    return {
        [PixType.TAX_IDENTIFIER]: formatIdentificationNumberAlphanumeric(value, helpers),
        [PixTypeEnum.TAX_IDENTIFIER]: formatIdentificationNumberAlphanumeric(value, helpers),
        [PixType.EMAIL]: value.toLowerCase(),
        [PixTypeEnum.EMAIL]: value.toLowerCase(),
        [PixType.PHONE]: formatAsPhoneNumber(value),
        [PixTypeEnum.PHONE]: formatAsPhoneNumber(value),
        [PixType.RANDOM]: formatAsRandomPixKey(value),
        [PixTypeEnum.RANDOM]: formatAsRandomPixKey(value),
    }[keyType];
}
export function removeFormatOfPixKeyByKeyTypeAlphanumeric(keyType, value, helpers) {
    if (!value)
        return;
    if (!keyType)
        return value;
    return {
        [PixType.TAX_IDENTIFIER]: helpers.unmaskCnpj(value),
        [PixTypeEnum.TAX_IDENTIFIER]: helpers.unmaskCnpj(value),
        [PixType.EMAIL]: value.toLowerCase(),
        [PixTypeEnum.EMAIL]: value.toLowerCase(),
        [PixType.PHONE]: value.replace('+55', '').replace(/\D/g, ''),
        [PixTypeEnum.PHONE]: value.replace('+55', '').replace(/\D/g, ''),
        [PixType.RANDOM]: value.replaceAll('-', ''),
        [PixTypeEnum.RANDOM]: value.replaceAll('-', ''),
    }[keyType];
}
